import './grandbevy2/style';
import FormStructure from './grandbevy2/form_structure';

export default FormStructure;